// extracted by mini-css-extract-plugin
export default {"button":"PersistenceInput_button__afTPT"};